import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Breadcrumbs, Typography, Paper } from '../';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      justifyContent: 'center',
      flexWrap: 'wrap'
    }
  };
});

var handleClick = function handleClick(e) {
  e.preventDefault();
  alert('You clicked a breadcrumb.');
};

export default function SMBreadcrumbs(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    separator: /*#__PURE__*/React.createElement(NavigateNextIcon, {
      fontSize: "small"
    }),
    "aria-label": "Breadcrumb"
  }, props.locations.map(function (location, index) {
    if (index === props.locations.length - 1) {
      return /*#__PURE__*/React.createElement(Typography, {
        key: "".concat(location.name, "-").concat(index),
        color: "textPrimary"
      }, location.name);
    } else {
      return /*#__PURE__*/React.createElement(Link, {
        key: "".concat(location.name, "-").concat(index),
        color: "inherit",
        href: location.url,
        onClick: handleClick
      }, location.name);
    }
  }))));
}